import PubSub from "underpub-js";

var FixedPopupButton = function(options) {

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

FixedPopupButton.prototype.init = function() {

	var self = this;

	self.$circleButton = self.options.$el.find(".js-circle-button");
	this.buttonShown = false;

	var throttled = _.throttle(function() {
		self.checkShowButton(self)
	}, 500);
	
	$(window).scroll(throttled);

	self.$circleButton.on("click", function() {
		self.hide();
	});

};

FixedPopupButton.prototype.checkShowButton = function(self) {

	if (!self.buttonShown) {

		var browserScroll = $(window).scrollTop();
		var browserHeight = $(window).height();

		if (browserScroll > (browserHeight * 0.75))
		{
			self.options.$el.addClass('shown');
			self.buttonShown = true;
		}

	}

};

FixedPopupButton.prototype.hide = function() {

	const self = this;

	self.options.$el.removeClass('shown');

};

export default FixedPopupButton;
